enum TRANG_THAI_MUA_SAM {
  NHAP = 0,
  CHO_DUYET = 1,
  TRUONG_BP_DA_DUYET = 2,
  KE_TOAN_DA_DUYET = 3,
  GD_DA_DUYET = 4,
  XOA = 6,
}
enum BO_PHAN_MUA_SAM {
  SALE = "Sale",
  MARKETING = "Marketing",
  MUA_HANG = "Mua hàng",
  KE_TOAN = "Kế toán",
  HANH_CHINH = "Hành chính",
  KI_THUAT = "Kĩ thuật",
  THUOC = "Thuốc",
  KINH = "Kính",
  LE_TAN = "Lễ tân",
  DIEU_DUONG = "Điều dưỡng",
  KHUC_XA = "Khúc xạ",
  NGOAI_TRU = "Ngoại trú",
  NOI_TRU = "Nội trú",
  XET_NGHIEM = "Xét nghiệm",
  CDHA = "Chẩn đoán hình ảnh",
  DIEN_TIM = "Điện tim",
  TU_VAN = "Tư vấn",
}
enum NGUON_THANH_TOAN {
  AEHSE = "AEHSE",
  Vinmec_Times_City = "Vinmec Times city",
  Lavelle = "Lavelle",
  Vision_spring = "Vision spring",
  An_Nam = "An Nam",
}
enum CHI_PHI_CHINH {
  ADM = "ADM",
  Ecopark_Hospital = "Ecopark Hospital",
  Khám = "Khám",
  Kính = "Kính",
  Marketing = "Marketing",
  Medical = "Medical",
  MKT_Sale = "MKT-Sale",
  Ortho_K = "Ortho K",
  Phau_thuat = "Phẫu thuật",
  Phau_thuat_khac = "Phẫu thuật khác",
  Phau_thuat_mong = "Phẫu thuật mộng",
  Phau_thuat_TTT = "Phẫu thuật TTT",
  Sale = "Sale",
  Vinmec = "Vinmec",
}
enum DIA_DIEM_MUA_SAM {
  VINMEC = "Vinmec Alina eye center",
  ECOPARK = "Ecopark Alina eye center",
}
enum ROLE_REQUEST_SHOPPING {
  NORMAL = "",
  TRUONG_BP = "",
  KIEM_SOAT_TC = "",
  BGD = "",
}
export {
  TRANG_THAI_MUA_SAM,
  ROLE_REQUEST_SHOPPING,
  BO_PHAN_MUA_SAM,
  DIA_DIEM_MUA_SAM,
  NGUON_THANH_TOAN,
  CHI_PHI_CHINH,
};
